// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"487":"f0b6056d","506":"a4542adb","585":"9219394c","594":"d07c01ad"}[chunkId] + ".css";
};